// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAddMilestoneButton_root__S8P+h","text__w2XKi":"PlasmicAddMilestoneButton_text__w2XKi__+KNNt","text__lWtTy":"PlasmicAddMilestoneButton_text__lWtTy__jDcVl"};